/**
 * 파일 참조값(dataUrl / http / fileId / fileUid / 객체)을 미리보기용 img src로 정규화.
 * 가입 서명(sign_uid) 등 Tus·CETUS_FILE 참조에 사용.
 */
export function resolvePreviewFileSrc(raw) {
  if (raw == null || raw === '') return '';

  let value = raw;
  if (Array.isArray(value)) {
    value = value[0];
  }
  if (typeof value === 'object' && value !== null) {
    value =
      value.file_uid ??
      value.fileUid ??
      value.file_id ??
      value.fileId ??
      value.uid ??
      value.fileIdOrUid ??
      value.dataUrl ??
      value.src ??
      '';
  }

  const str = String(value).trim();
  if (!str) return '';
  if (
    str.startsWith('data:') ||
    str.startsWith('http') ||
    str.startsWith('/') ||
    str.startsWith('blob:')
  ) {
    return str;
  }
  if (Number.isNaN(Number(str))) {
    return `/api/glow/files/view?fileId=${encodeURIComponent(str)}`;
  }
  return `/api/glow/files/viewByUid/${encodeURIComponent(str)}`;
}

/**
 * 회원가입 formData / flat dataJson에서 서명 이미지 src 추출.
 * 레거시 writer_sign(dataUrl)과 신규 sign_uid(file uid/id) 모두 지원.
 * dataJson.layoutRows 안에 flat 행이 들어 있는 경우도 탐색한다.
 */
export function resolveSignupSignatureSrc(...sources) {
  const pick = (src) => {
    if (src == null || typeof src !== 'object') return '';
    return resolvePreviewFileSrc(
      src.writer_sign ??
        src.sign_uid ??
        src.signUid ??
        src.stamp_uid ??
        src.stampUid
    );
  };

  for (const src of sources) {
    if (src == null || typeof src !== 'object') continue;
    const direct = pick(src);
    if (direct) return direct;

    const layoutRows = src.layoutRows;
    if (layoutRows && typeof layoutRows === 'object') {
      for (const rows of Object.values(layoutRows)) {
        if (!Array.isArray(rows)) continue;
        for (const row of rows) {
          const fromRow = pick(row);
          if (fromRow) return fromRow;
        }
      }
    }
  }
  return '';
}
